import React, { Component, Fragment } from "react";
import FormView from "../components/FormView";
import Title from "../components/SidePanel/Title";
import { Switch, Route, Redirect } from 'react-router' // react-router v4
import SignUp from "../components/SignUp";
import TenantSignUpContainer from "../containers/TenantSignUpContainer";
import LandlordSignupContainer from "../containers/LandlordSignupContainer";
import { connect } from "react-redux";
import Header from "../components/Header";

class SignUpRoute extends Component {

    render() {
        const { loggedIn } = this.props;
        if ( loggedIn )
            return <Redirect to="/user"/>
        return (
            <Fragment>
                <Header sticky/>
                <Switch>
                    <Route exact path="/signup" render={props => {
                        return (
                        <FormView
                            content={ <SignUp {...props}/> }
                            sideContent={ <Title/> }
                        />
                    );}}
                    />
                    <Route path="/signup/tenant" component={TenantSignUpContainer}/>
                    <Route path="/signup/landlord" component={LandlordSignupContainer}/>
                    <Redirect to="/signup"/>
                </Switch>
            </Fragment>
        );
    }

}

export default connect(
    state => ({
        loggedIn: state.user.bearerToken ? true : false
    })
)( SignUpRoute );